module.exports = __webpack_public_path__ + "static/media/icon-street.78b8e880.svg";